import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

export const select: TRuleWithTheme = ({ theme }) => {
    return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(4),
        width: 'unset',

        '&.ant-select': {
            height: 'unset',
            width: 'unset',
            minHeight: 'unset',

            '& > .ant-select-arrow': {
                marginTop: 'unset',
                top: 'unset',
                fontSize: 'unset',
                height: 'unset',
                insetInlineStart: 'unset',
                insetInlineEnd: 'unset',
                position: 'absolute',
                right: 0,
            },
        },

        '&.ant-select-single': {
            border: 'none !important',
            height: '18px !important',
            padding: '0px !important',
            position: 'relative',

            '& > .ant-select-content': {
                ...theme.typography.ParagraphSmallMedium,
                color: theme.colors.black,
                fontWeight: 500,
            },
        },

        '&.ant-select-multiple': {
            border: 'none !important',
            height: '18px !important',
            padding: '0px !important',
            position: 'relative',
            minWidth: 0,
            maxWidth: '100%',
            cursor: 'pointer !important',

            '& > .ant-select-content': {
                ...theme.typography.ParagraphSmallMedium,
                color: theme.colors.black,
                fontWeight: 500,
                flexWrap: 'nowrap',
                columnGap: theme.spacing(8),
                marginRight: theme.spacing(24),

                '&::before': {
                    display: 'none',
                },
            },

            '& .ant-select-content-item-prefix': {
                display: 'contents',
            },

            '& .ant-select-content-item-suffix': {
                marginInlineStart: '0 !important',
            },

            '& .ant-select-input': {
                ...theme.typography.ParagraphSmallMedium,
                fontWeight: 500,
                color: theme.colors.foregroundsTertiary,
                cursor: 'pointer',
            },

            '&.ant-select-open .ant-select-input': {
                cursor: 'text',
            },

            '&.ant-select-open .ant-select-placeholder': {
                color: theme.colors.foregroundsPlaceholder,
            },

            '& .ant-select-selection-item': {
                ...theme.typography.ParagraphSmallMedium,
                fontWeight: 500,
                margin: 0,
                padding: '0 !important',
                background: 'transparent',
                border: 'none',
                height: 'unset',
            },

            '& .ant-select-selection-item-remove': {
                display: 'none',
            },

            '& .ant-select-placeholder': {
                insetInlineStart: 0,
                color: theme.colors.black,
            },

            '& .ant-select-clear': {
                insetInlineEnd: 0,
                backgroundColor: theme.colors.white,
            },
        },
    };
};

export const label: TRuleWithTheme = ({ theme }) => ({
    ...theme.typography.ParagraphSmallMedium,
    fontWeight: 500,
});

export const caret: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.black,
    transform: 'scale(1, 1)',
    transition: 'all 0.3s ease-in-out',
});

export const caretOpen: TRuleWithTheme = combineRules(caret, ({ theme }) => ({
    transform: 'scale(1, -1)',
    color: theme.colors.accentSecondary,
}));

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'grid',
    rowGap: theme.spacing(4),
});

export const dropdown: TRuleWithTheme = ({ theme }) => ({
    width: '225px !important',
});

export const check: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.tabsSelected,
});
